import styled, { css } from 'styled-components';

export const MerlinWrapper = styled.div`
  ${({ theme, $showIframe }) => css`
    display: ${$showIframe ? 'flex' : 'none'};
    z-index: 1000;
    position: fixed;
    right: 0;
    bottom: 0;
    height: 100vh;
    width: 480px;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.white.primary};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 100vh;
      width: 100%;
    }
  `}
`;

export const Merlin = styled.iframe`
  z-index: 1000;
  height: 100%;
  width: 100%;
  border: 0;
  border-left: 1px solid #CDD8DF;
`;
